import { HelpOutline } from "@mui/icons-material";
import { Typography } from "@mui/material";
import { ReactElement } from "react";

import { FlexBox } from "./FlexBox";
import { InternalLink } from "./Link";

export default function SupportWidget(): ReactElement | null {
  return (
    <FlexBox gap="2">
      <InternalLink
        rel="noopener noreferrer"
        target="_blank"
        color="inherit"
        aria-label="Open support knowledge base (opens in new tab)"
        sx={{
          p: 2,
          width: "100%",
          display: "flex",
          alignItems: "center",
          textTransform: "none",
          textDecoration: "none",
          "&:focus,:focus-visible": {
            outline: "none",
            backgroundColor: "rgba(0,0,0,0.12)",
          },
        }}
        to={"https://support.scaletowin.com/knowledge-base"}
      >
        <HelpOutline sx={{ mr: "10px" }} />
        <Typography
          className="listItemText"
          display="inline"
          sx={{ mb: "2px" }}
        >
          Support
        </Typography>
      </InternalLink>
    </FlexBox>
  );
}
